import React from "react";
import PropTypes from "prop-types";
import { Frame } from "@bitesite/react-figstrap";
import styled from "styled-components/macro";
import { Icon } from "@iconify/react";
import { Button, inEmbedMode, Link } from "../../../odc-ui";

const ThankYouMessage = styled(Frame)`
  font-size: 30px;
`;

const Message = styled.div`
  text-align: center;
`;

const ExternalPurchaseSuccess = ({
  hasExistingAccount,
  message,
  newAccountMessage,
  detailsUrl,
}) => {
  const authenticated = window.gon.current_user;

  return (
    <Frame vertical gap={32}>
      <ThankYouMessage gap={5} alignItems="center" justifyContent="center">
        <Icon icon="material-symbols:check-circle" />
        <div>Thank You for your purchase!</div>
      </ThankYouMessage>
      <Message>
        {message}{" "}
        {authenticated ? (
          <>
            You can view more details through your{" "}
            <Link
              href={detailsUrl}
              target="_blank"
              type={inEmbedMode() ? "embed" : ""}
            >
              Healthcoin® account
            </Link>
            {inEmbedMode() ? "" : ", or return to the shop"}.
          </>
        ) : (
          <>
            {hasExistingAccount ? (
              <>
                {" "}
                You can log into your{" "}
                <Link type={inEmbedMode() ? "embed" : ""} href="/users/sign_in">
                  Healthcoin®
                </Link>{" "}
                account for more details.
              </>
            ) : (
              newAccountMessage
            )}
          </>
        )}
      </Message>
      {!inEmbedMode() && (
        <Frame justifyContent="center">
          <Button
            type="primary-paige"
            href="https://consultpaige.com/product-category/healthcoin/"
          >
            Return to the shop
          </Button>
        </Frame>
      )}
    </Frame>
  );
};

ExternalPurchaseSuccess.propTypes = {
  message: PropTypes.string.isRequired,
  hasExistingAccount: PropTypes.bool,
  detailsUrl: PropTypes.string.isRequired,
  newAccountMessage: PropTypes.string,
};

export default ExternalPurchaseSuccess;
